import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "location-card-zip" }
const _hoisted_2 = {
  key: 0,
  class: "location-card-info-zip"
}
const _hoisted_3 = { class: "location-card-info-title-zip" }
const _hoisted_4 = { class: "store-content" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "distance-store" }
const _hoisted_7 = { class: "container-general" }
const _hoisted_8 = { class: "left-side" }
const _hoisted_9 = { class: "address-store" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "phone-number-section" }
const _hoisted_13 = { class: "telephone-store" }
const _hoisted_14 = ["href", "data-storename", "data-storephone"]
const _hoisted_15 = { class: "right-side" }
const _hoisted_16 = ["href", "data-storename"]
const _hoisted_17 = { class: "button-directions" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { id: " Map / Directions" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Arrow Path",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.5 13.369C7.5 12.911 7.873 12.539 8.33 12.539H16.124L12.5402 16.5605C12.1728 16.9728 12.2091 17.6049 12.6214 17.9724C13.0337 18.34 13.666 18.3037 14.0335 17.8913L19.1229 12.1807C19.4246 11.8421 19.4253 11.3313 19.1244 10.9919L14.0325 5.2484C13.6661 4.8351 13.034 4.79718 12.6208 5.1637C12.2078 5.53006 12.1698 6.16185 12.5361 6.57499L16.05 10.539H8.33C6.77 10.539 5.5 11.808 5.5 13.369V18.164C5.5 18.7163 5.94772 19.164 6.5 19.164C7.05228 19.164 7.5 18.7163 7.5 18.164V13.369Z",
      fill: "#006FA6"
    })
  ])
], -1)
const _hoisted_19 = { class: "directions-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dealership)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", {
                class: "store-name",
                href: _ctx.dealership.url,
                target: "_self",
                role: "link",
                tabindex: "-1"
              }, [
                _createTextVNode(_toDisplayString(_ctx.dealership.storeName) + " ", 1),
                _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.dealership.distance?.toFixed()) + " " + _toDisplayString(_ctx.$t('srp.common.mi')) + ") ", 1)
              ], 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.dealership.address), 1),
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.dealership.city) + ", " + _toDisplayString(_ctx.dealership.state) + " " + _toDisplayString(_ctx.dealership.zip), 1),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, [
                  (_ctx.dealership.phone)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: 'tel:' + _ctx.dealership.phone,
                        tabindex: "-1",
                        class: "ancStorePhone",
                        "data-storename": _ctx.dealership.storeName,
                        "data-storephone": _ctx.dealership.phone
                      }, _toDisplayString(_ctx.dealership.phone), 9, _hoisted_14))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                href: _ctx.directionsLink,
                class: "directions-link",
                role: "link",
                tabindex: "-1",
                target: "_blank",
                "data-storename": _ctx.dealership.storeName,
                "aria-describedby": "audioeye_new_window_message"
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _renderSlot(_ctx.$slots, "icon-direction-image", {}, () => [
                    _hoisted_18
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _renderSlot(_ctx.$slots, "direction-direction-text", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.$t('srp.common.getDirections')), 1)
                  ])
                ])
              ], 8, _hoisted_16)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}